import React, { useEffect, useState } from 'react'
import toast from 'react-hot-toast';
import { toastConfig } from '../../constants/other.config';
import PatientNoteDataCRUD from '../../services/general/patientNoteData.api'
import PatientOrdersCRUD from '../../services/general/patientOrders.api';
import { CAccordion, CAccordionBody, CAccordionHeader, CAccordionItem, CFormLabel } from '@coreui/react';

const ShowAddedOrders = ({ patientID,patientDBData, noteID  }) => {
   
    const [orders, setOrders] = useState([])


    console.log("orders====>", orders)

    const fetchOrders = async () => {
        try {

              let patientordersData = patientDBData?.ordersData
                .filter(item => item.medication?.noteID === noteID)

            // let data = await PatientOrdersCRUD('Get', "", patientID);

            // data = JSON.parse(data?.d).Data || [];

            // const parsedOrders = data?.map(order => ({
            //     // ...order,
            //     date: order.date,
            //     medication: JSON.parse(order.medication)
            // }))
            // console.log("orders", parsedOrders)
            setOrders(patientordersData)

        } catch (error) {
            console.error('Failed to fetch or parse orders:', error);
        }
    };

    console.log("orders========>",orders)

    useEffect(() => {
        fetchOrders()
    }, [])

      const userData = JSON.parse(localStorage.getItem('user'))
      const role = userData?.Role

    return (
      <div className={` ${role == 'provider' ? 'accordion-dark' : ' '}`}>
        <CAccordion activeItemKey={0} className="homeAccordion">
          <div className="  p-3      " >
            {orders?.length > 0 ? (
              orders.map((item, idx) => {
                const currentOrder = item?.medication
                return (
                  <CAccordionItem className="mt-2 border ">
                    <CAccordionHeader>{currentOrder.diagnosis}</CAccordionHeader>
                    <CAccordionBody>
                      <div key={idx} className="mb-3">
                        <div className="card shadow-sm " style={{ background: role == 'provider' ? '#191919' : '' }}>
                          <div className="card-body">
                            {/* Date */}
                            <div className="">
                              <div>
                                <CFormLabel className="me-2 fw-bold">Date :</CFormLabel>
                                {(() => {
                                  if (!item?.date) return
                                  const parts = item?.date?.split('-')
                                  if (!parts || parts.length !== 3) return ''
                                  const [month, day, year] = parts
                                  const date = new Date(`${year}-${month}-${day}`)
                                  return new Intl.DateTimeFormat('en-US', {
                                    day: '2-digit',
                                    month: '2-digit',
                                    year: 'numeric',
                                  }).format(date)
                                })()}
                              </div>
                              {/* {currentOrder?.diagnosis && (
                                <p className="mb-1 " style={{ marginTop: '-8px' }}>
                                  <strong>Diagnosis:</strong> {currentOrder.diagnosis}
                                </p>
                              )} */}
                            </div>

                            {/* Imaging */}
                            {currentOrder?.imaging?.imagingTypes?.length > 0 && (
                              <div className="mb-2">
                                <p className="text-secondary fw-bold mb-1">Imaging</p>
                                <ul>
                                  {currentOrder.imaging.imagingTypes.map((imagingItem, iIdx) => (
                                    <li className="p-0 m-0" key={iIdx}>
                                      {imagingItem?.type}
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            )}

                            {/* Labs */}
                            {currentOrder?.lab?.labs?.length > 0 && (
                              <div className="mb-2">
                                <p className="text-secondary fw-bold mb-1">Labs</p>
                                <ul>
                                  {currentOrder.lab.labs.map((labItem, lIdx) => (
                                    <li className="p-0 m-0" key={lIdx}>
                                      {labItem?.lab}
                                      {labItem?.reason && ` - Reason for ${labItem.lab}: ${labItem.reason}`}
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            )}

                            {/* Medications */}
                            {currentOrder?.medication?.medication?.length > 0 && (
                              <div className="mb-2">
                                <p className="text-secondary fw-bold mb-1">Medications</p>
                                <ul>
                                  {currentOrder.medication.medication.map((medItem, mIdx) => (
                                    <li className="p-0 m-0" key={mIdx}>
                                      {medItem?.name} {medItem?.dosage} {medItem?.route}
                                      {medItem?.frequency && ` ${medItem.frequency}`}
                                      {medItem?.reason && ` - ${medItem.reason}`}
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            )}

                            {/* Miscellaneous */}
                            {currentOrder?.miscellaneous?.miscellaneous?.length > 0 && (
                              <div className="mb-2">
                                <p className="text-secondary fw-bold mb-1">Miscellaneous</p>
                                <ul>
                                  {currentOrder.miscellaneous.miscellaneous.map((miscItem, xIdx) => (
                                    <li className="p-0 m-0" key={xIdx}>
                                      {miscItem.type}
                                    </li>
                                  ))}
                                </ul>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                    </CAccordionBody>
                  </CAccordionItem>
                )
              })
            ) : (
              <div className="text-center text-muted py-3">No orders available.</div>
            )}
          </div>
        </CAccordion>
      </div>
    )
}

export default ShowAddedOrders
